export default __webpack_public_path__ + "static/rachel-0653f8301075506fc7d770b5090bb650.png";